import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum InvoiceExportTypeId {
  GENERAL = 1,
  SYMFONIA = 2,
  MONEY_S3 = 3,
  ISDOC = 4,
  ENOVA = 5,
  POHODA = 6,
  JPK_V7M = 7,
  ZIP = 8,
  PDF = 9,
  XLS = 10,
  QUIT = 11,
  HELIOS_RED = 12,
  OMEGA_KROS = 13,
  SAGA = 14,
}

export enum InvoiceExportTypeKey {
  GENERAL = 'summary',
  SYMFONIA = 'symfonia',
  MONEY_S3 = 'xml-money-s3',
  ISDOC = 'isdoc',
  ENOVA = 'enova',
  POHODA = 'xml-pohoda',
  JPK_V7M = 'jpk-v7m',
  ZIP = 'zip',
  PDF = 'pdf',
  XLS = 'xls',
  QUIT = 'xml-quit',
  HELIOS_RED = 'csv-helios-red',
  OMEGA_KROS = 'omega-kros',
  SAGA = 'saga',
}

export class InvoiceExportType extends Codebook<InvoiceExportTypeId> {
  static readonly GENERAL = new InvoiceExportType(
    InvoiceExportTypeId.GENERAL,
    () => $t('Summary'),
    'file-invoice',
    InvoiceExportTypeKey.GENERAL,
  )
  static readonly ZIP = new InvoiceExportType(
    InvoiceExportTypeId.ZIP,
    () => $t('ZIP file with PDF documents'),
    'file-zip',
    InvoiceExportTypeKey.ZIP,
  )
  static readonly PDF = new InvoiceExportType(
    InvoiceExportTypeId.PDF,
    () => $t('PDF summary'),
    'file-pdf',
    InvoiceExportTypeKey.PDF,
  )
  static readonly XLS = new InvoiceExportType(
    InvoiceExportTypeId.XLS,
    () => $t('XLS'),
    'file-xls',
    InvoiceExportTypeKey.XLS,
  )
  static readonly SYMFONIA = new InvoiceExportType(
    InvoiceExportTypeId.SYMFONIA,
    () => $t('Symfonia'),
    'file',
    InvoiceExportTypeKey.SYMFONIA,
  )
  static readonly MONEY_S3 = new InvoiceExportType(
    InvoiceExportTypeId.MONEY_S3,
    () => $t('XML for Money S3'),
    'file-xml',
    InvoiceExportTypeKey.MONEY_S3,
  )
  static readonly ISDOC = new InvoiceExportType(
    InvoiceExportTypeId.ISDOC,
    () => $t('ISDOC'),
    'file',
    InvoiceExportTypeKey.ISDOC,
  )
  static readonly ENOVA = new InvoiceExportType(
    InvoiceExportTypeId.ENOVA,
    () => $t('Enova'),
    'file',
    InvoiceExportTypeKey.ENOVA,
  )
  static readonly POHODA = new InvoiceExportType(
    InvoiceExportTypeId.POHODA,
    () => $t('XML for Pohoda'),
    'file-xml',
    InvoiceExportTypeKey.POHODA,
  )
  static readonly JPK_V7M = new InvoiceExportType(
    InvoiceExportTypeId.JPK_V7M,
    () => $t('JPK-V7M'),
    'file',
    InvoiceExportTypeKey.JPK_V7M,
  )
  static readonly QUIT = new InvoiceExportType(
    InvoiceExportTypeId.QUIT,
    () => $t('XML for Quit'),
    'file-xml',
    InvoiceExportTypeKey.QUIT,
  )
  static readonly HELIOS_RED = new InvoiceExportType(
    InvoiceExportTypeId.HELIOS_RED,
    () => $t('CSV for Helios Red'),
    'file-csv',
    InvoiceExportTypeKey.HELIOS_RED,
  )
  static readonly OMEGA_KROS = new InvoiceExportType(
    InvoiceExportTypeId.OMEGA_KROS,
    () => $t('XLS for Omega Kros'),
    'file-xls',
    InvoiceExportTypeKey.OMEGA_KROS,
  )
  static readonly SAGA = new InvoiceExportType(
    InvoiceExportTypeId.SAGA,
    () => $t('XML for Saga'),
    'file-xml',
    InvoiceExportTypeKey.SAGA,
  )

  private constructor(
    public readonly id: InvoiceExportTypeId,
    public readonly name: () => string,
    public readonly icon: string,
    public readonly key: InvoiceExportTypeKey,
  ) {
    super(id)
  }
}
